import { Outlet } from "react-router-dom";
import NavBar from "./Navbar";
import Footer from "./Footer"; // Import Footer component

export default function Layout() {
    return (
        <div className="relative">
            <NavBar />
            <main className="min-h-screen">
                <Outlet /> {/* The nested page content */}
            </main>
            <Footer /> {/* Footer added here */}
        </div>
    );
}
